import _axios from '@/plugins/axios';
import { RepoError } from '../../../lib/Errors';

export default {
	async getAllReleaseNotes () {
		const response = await _axios.get('/releasenote');
		if (response.data.statusCode === 200) {
			return response.data;
		}
		throw new RepoError('Error getting release notes');
	},
	async getReleaseNoteById (id) {
		const response = await _axios.get(`/releasenote/${id}`, {
			responseType: 'blob',
		});
		if (response.status === 200) {
			return response;
		}
		throw new RepoError('Error getting release note by ID');
	},
	async addReleaseNote (body) {
		const response = await _axios.post('/releasenote/', body);
		if (response.data.resFlag) {
			return response.data;
		}
		throw new RepoError('Error adding release note');
	},
	async deleteReleaseNote (id) {
		const response = await _axios.delete(`/releasenote/${id}`);
		if (response.data.resFlag) {
			return response.data;
		}
		throw new RepoError('Error deleting release note');
	},
};
